export default {

  methods: {
    showSuccessMessage(message) {
      this.$store.dispatch('showSuccessMessage', message);
    },
    showErrorMessage(message) {
      this.$store.dispatch('showErrorMessage', message);
    },
    showValidationErrorMessage() {
      this.showErrorMessage('Validation error. Please check validation error messages.');
    },
    showWarningMessage(message) {
      this.$store.dispatch('showWarningMessage', message);
    },
    showInfoMessage(message) {
      this.$store.dispatch('showInfoMessage', message);
    },
    showError(error) {
      this.$store.dispatch('showError', error);
    },
    clearMessages() {
      this.$store.dispatch('clearMessages');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MPayMessagesMixin.js